import axios from "axios";
import { GetAllGGNotificationCropDTO, GetAllGGNotificationCropFiltersDTO, GGNotificationCropDTO } from "./dto";
import { GGNotificationCropService } from "./service";
import { keycloak } from "../../../../../lib/keycloak";

export class GGNotificationCropServiceImpl implements GGNotificationCropService {

    public CreateGGNotificationCrop(data: GGNotificationCropDTO): Promise<void> {
        return axios.post("/api/gg-notification-crop",
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public GetAllGGNotificationCrop(filters: GetAllGGNotificationCropFiltersDTO): Promise<GetAllGGNotificationCropDTO> {
        return axios.get("/api/gg-notification-crop", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page ? filters.page : 0,
                sort: filters.sort,
                order: filters.order,
                ggNotificationId: filters.ggNotificationId
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public GetGGNotificationCropById(id: string): Promise<GGNotificationCropDTO> {
        return axios.get("/api/gg-notification-crop/" + id, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public DeleteGGNotificationCrop(id: string): Promise<void> {
        return axios.delete("/api/gg-notification-crop/" + id,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }
}